import Base from "@/api/Base";

export default class Save extends Base
{
	setJobProfileId (v)
	{
		this.jobProfileId = v;
		return this;
	}

	setCompanyName (v)
	{
		this.data.companyName = v;
		return this;
	}

	setCompanyNumber (v)
	{
		this.data.companyNumber = v;
		return this;
	}

	setCountry (v)
	{
		this.data.country = v;
		return this;
	}

	setSalutation (v)
	{
		this.data.salutation = v;
		return this;
	}

	setFirstName (v)
	{
		this.data.firstName = v;
		return this;
	}

	setLastName (v)
	{
		this.data.lastName = v;
		return this;
	}

	setZip (v)
	{
		this.data.zip = v;
		return this;
	}

	setCity (v)
	{
		this.data.city = v;
		return this;
	}

	setStreet (v)
	{
		this.data.street = v;
		return this;
	}

	setStreetNumber (v)
	{
		this.data.streetNumber = v;
		return this;
	}

	setWebsite (v)
	{
		this.data.website = v;
		return this;
	}

	setRole (v)
	{
		this.data.role = v;
		return this;
	}

	setPhone (v)
	{
		this.data.phone = v;
		return this;
	}

	setExternalCompanyName (v)
	{
		this.data.externalCompanyName = v;
		return this;
	}

	setExternalCompanyNumber (v)
	{
		this.data.externalCompanyNumber = v;
		return this;
	}

	getMethod ()
	{
		return 'PUT';
	}

	getUrl ()
	{
		return '/stellenprofil/' + this.jobProfileId + '/fragebogen/legitimierung';
	}
}
